// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2ECjD","label":"Labeled_label__1ILwg","divider":"Labeled_divider__1KgN7"};